<template>
    <div class="file-list-inside">
        <div class="file-list-inside-table">
            <el-table ref="fileListInsideTable" :data="list" @expand-change="expandChangeEvent" @selection-change="handleSelectionChange" @sort-change="handleSortChange" row-key="docId" style="width: 100%">
                <el-table-column type="expand" fixed header-align="center" align="center" width="34">
                    <template slot-scope="scope">
                        <div class="expand-table">
                            <el-table :data="scope.row.tasks || []" :show-header="false" :span-method="handleSpanMethod" :row-class-name="handleRowClassName" :empty-text="scope.row.docStatus !== 'pre-translated' ? '文档解析或预翻译未完成，请稍后查看' : '暂无数据'">
                                <el-table-column width="34" fixed></el-table-column>
                                <el-table-column width="42" fixed></el-table-column>
                                <el-table-column width="340" fixed>
                                    <template slot-scope="taskScope">
                                        <div style="padding-left: 44px;">{{taskScope.row.taskName}} {{$t('project.component_FileListInside_tips_1')}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="220"></el-table-column>
                                <el-table-column min-width="100"> 
                                    <template slot-scope="taskScope">
                                        <span>{{taskScope.row.range.wordCount}} {{$t('project.component_FileListInside_tips_2')}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" min-width="200">
                                    <template slot-scope="taskScope">
                                        <div class="workflow-step-item" :class="{'active': taskScope.row.state === 1, 'finashed': taskScope.row.state === 2}">
                                            <div class="task-progress" style="margin-top: 4px; max-width: 150px;">
                                                <el-progress :percentage="taskScope.row.progress" :stroke-width="20" color="#D3F4EC" :show-text="false"></el-progress>
                                                <div class="percentage">{{taskScope.row.progress}}%</div>
                                            </div>
                                            <div class="margin-l-10">{{taskScope.row.typeDesc}}</div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="160">
                                    <template slot-scope="taskScope">
                                        <svg-icon name="ib-user-plus" className="fonts-18 color-999 margin-r-5"></svg-icon>
                                        <template v-if="taskScope.row.actively">
                                            <template v-if="['REJECTED', 'ASSIGNED'].indexOf(taskScope.row.status) > -1">
                                                <span :class="taskScope.row.status">
                                                    <template v-if="taskScope.row.status === 'REJECTED'">
                                                        <el-tooltip :content="`${$t('project.component_FileListInside_tips_3')}`+taskScope.row.remark" placement="top">
                                                            <span>（{{taskScope.row.returned ? $t('project.component_FileListInside_tips_4') : ''}}{{taskScope.row.statusDesc}}）</span>
                                                        </el-tooltip>
                                                    </template>
                                                    <template v-else>（{{taskScope.row.returned ? $t('project.component_FileListInside_tips_4') : ''}}{{taskScope.row.statusDesc}}）</template>
                                                </span>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <span class="color-999" v-if="taskScope.row.returned">{{$t('project.component_FileListInside_tips_5')}}</span>
                                        </template>
                                        <template v-if="taskScope.row.assignee && taskScope.row.assignee.length">
                                            <el-tooltip :content="taskScope.row.assignee.length ? $t('project.component_FileListInside_tips_6') : $t('project.component_FileListInside_tips_7')" placement="top">
                                                <span class="cursor-pointer table-link margin-l-5" @click="assignCommandEvent('assign', taskScope)">
                                                    <template v-for="(assignee, assigneeIndex) in taskScope.row.assignee">
                                                        <template v-if="assigneeIndex < 2">{{assignee.alias}}</template>
                                                        <template v-if="assigneeIndex < taskScope.row.assignee.length - 1 && assigneeIndex < 1 ">,</template>
                                                    </template>
                                                    <span class="margin-l-5" v-if="taskScope.row.assignee.length > 2">{{$t('project.component_FileListInside_tips_8', {size: taskScope.row.assignee.length})}}</span>
                                                </span>
                                            </el-tooltip>
                                        </template>
                                        <template v-else><span class="color-999 cursor-pointer" @click="assignCommandEvent('assign', taskScope)">{{$t('project.component_FileListInside_tips_9')}}</span></template>
                                        
                                    </template>
                                </el-table-column>
                                <el-table-column min-width="160" class-name="eidt-col">
                                    <template slot-scope="taskScope">
                                        <div class="height-full flex flex-align-center" :class="{'timeout': taskScope.row.overdue}">
                                            <svg-icon name="ib-alarm" className="fonts-18 color-999 margin-r-10"></svg-icon>
                                            <template v-if="taskScope.row.status === 'FINISHED' || !$checkPermission('project:detailRouter:deadline')">
                                                <span v-if="taskScope.row.deadlineTime">{{getTimeText(taskScope.row.deadlineTime)}}</span>
                                                <span v-else class="color-999">{{$t('project.component_FileListInside_tips_10')}}</span>
                                            </template> <!-- format="yyyy-MM-dd HH:mm" -->
                                            <template v-else>
                                                <el-date-picker popper-class="hide-time"
                                                    v-model="taskScope.row.deadlineTime"
                                                    type="datetime"
                                                    :editable="false"
                                                    :clearable="false"
                                                    :placeholder="$t('project.component_FileListInside_input_placeholder_1')"
                                                    prefix-icon="null"
                                                    default-time="12:00:00"
                                                    format="MM-dd HH:mm"
                                                    :picker-options="pickerOptions(scope.row.createTime)"
                                                    @change="val => setDeadLineTime(val, scope, taskScope)" style="width: 100%;">
                                                </el-date-picker>
                                            </template>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="110" fixed="right">
                                    <template slot-scope="taskScope">
                                        <template v-if="taskScope.row.status !== 'FINISHED' && $checkPermission('project:detailRouter:assignTask')">
                                            <el-tooltip :content="$t('project.component_FileListInside_tips_11')" placement="top">
                                                <el-button type="text" class="button-text" @click="assignCommandEvent('info', taskScope)"><svg-icon name="ib-ecard"></svg-icon></el-button>
                                            </el-tooltip>
                                        </template>
                                        <template v-if="taskScope.row.status == 'FINISHED' && $checkPermission('project:detailRouter:returnToPrevTask')">
                                            <el-tooltip :content="$t('project.component_FileListInside_tips_12')" placement="top">
                                                <el-button type="text" class="button-text" @click="rejectToEvent(taskScope.row)"><svg-icon name="ib-reject"></svg-icon></el-button>
                                            </el-tooltip>
                                        </template>
                                        <template v-if="['REJECTED'].indexOf(taskScope.row.status) === -1">
                                            <el-tooltip :content="$t('project.component_FileListInside_tips_13')" placement="top">
                                                <el-button type="text" class="button-text" @click="showOfferDialog(taskScope.row)"><svg-icon name="ib-rmb"></svg-icon></el-button>
                                            </el-tooltip>
                                        </template>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column type="selection" fixed :reserve-selection="true" :selectable="handleSetSelectionEnable" header-align="center" align="center" width="42"></el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_1')" fixed sortable="custom" column-key="FILENAME" width="340" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="file-icon">
                            <svg-icon :name="`ic-${config.FILE_TYPE_MATCH['.' + scope.row.fileType] ? config.FILE_TYPE_MATCH['.' + scope.row.fileType].icon : ''}`"></svg-icon>
                        </div>
                        <template v-if="scope.row.docStatus === 'pre-translated'">
                            <router-link :to="`/workbench/editer?id=${scope.row.docId}`" class="table-link">{{ scope.row.originalFilename }}</router-link>
                        </template>
                        <template v-else>{{ scope.row.originalFilename }}</template>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_2')" width="220">
                    <template slot-scope="scope">
                        <language-direction :source="scope.row.sourceLang" :target="scope.row.targetLang" type="half"></language-direction>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_3')" prop="sourceWords" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.sourceWords || '-'}} {{$t('project.component_FileListInside_tips_14')}} / {{scope.row.sourceCharacters || '-'}} {{$t('project.component_FileListInside_tips_15')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_4')" header-align="center" align="center" min-width="200">
                    <template slot-scope="scope">
                        <template v-if="scope.row.docStatus === 'pre-translated'">
                            <div class="workflow-wrapper">
                                <div class="list">
                                    <template v-for="(item, index) in scope.row.stages" >
                                        <div class="item" :class="{'active': item.alight}" :key="`workflow-item-${index}`">
                                            <div class="name">{{item.name}}</div>
                                            <div class="point"></div>
                                        </div>
                                        <div class="line" :key="`workflow-line-${index}`" v-if="index < scope.row.stages.length - 1"></div>
                                    </template>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="scope.row.docStatus === 'limited'">
                            <svg-icon name="ib-warning-o" class="fonts-15 color-error"></svg-icon>
                            <span class="margin-x-10">{{$t('project.component_FileListInside_tips_16')}}</span><br/>
                            <el-tooltip :content="$t('project.component_FileListInside_tips_17')" placement="top">
                                <el-button type="text" class="button-link" @click="showPayCharDialog">{{$t('project.component_FileListInside_btn_1')}}</el-button>
                            </el-tooltip>
                            <el-button type="text" class="button-link" @click="executeAction('retranslate', scope.row)">{{$t('project.component_FileListInside_btn_2')}}</el-button>
                        </template>
                        <template v-else-if="scope.row.docStatus.indexOf('error') > -1">
                            <svg-icon name="ib-warning-o" class="fonts-15 color-error"></svg-icon><span class="color-666666 margin-l-10">{{scope.row.docStatusDesc}}</span>
                        </template>
                        <template v-else>
                            <i class="el-icon-loading fonts-15"></i><span class="color-666666 margin-l-10">{{scope.row.docStatusDesc}}</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_5')" prop="sourceWords" min-width="160" show-overflow-tooltip>{{doc.createBy}}</el-table-column>
                <el-table-column :label="$t('project.component_FileListInside_table_column_6')" sortable="custom" column-key="CREATE_TIME" min-width="160">
                    <template slot-scope="scope">
                        <svg-icon name="ib-upload-file" className="fonts-18 color-999 margin-r-10"></svg-icon>{{getTimeText(scope.row.createTime)}}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="译后编辑率" width="100"> -->
                    <!-- 译后编辑率 -->-
                <!-- </el-table-column> -->
                <el-table-column :label="$t('project.component_FileListInside_table_column_7')" width="110" fixed="right">
                    <template slot-scope="scope">
                        <template v-if="scope.row.docStatus === 'pre-translated'">
                            <el-tooltip :content="$t('project.component_FileListInside_tips_18')" placement="top">
                                <span class="margin-r-10"><el-button type="text" class="button-text" @click="showSplitDialog(scope.row)"><svg-icon name="ib-split-task"></svg-icon></el-button></span>
                            </el-tooltip>
                        </template>
                        <template v-if="scope.row.docStatus === 'pre-translated' || scope.row.docStatus === 'limited' || scope.row.docStatus.indexOf('error') > -1">
                            <el-popover placement="bottom" popper-class="operate-popover">
                                <div>
                                    <template v-if="scope.row.docStatus === 'pre-translated'">
                                        <div class="operate-btn" v-permission="`project:detailRouter:detail`" @click="$router.push(`/workbench/editer?id=${scope.row.docId}`)"><svg-icon name="ib-open-eye"></svg-icon> {{$t('project.component_FileListInside_tips_19')}}</div>
                                        <el-dropdown placement="left-start" trigger="hover" class="download-operate-dropdown" @command="(command)=>handleMoreCommand(command, scope.row)">
                                            <div class="operate-btn flex flex-justify-between flex-align-center"><span><svg-icon name="ib-download-1"></svg-icon>{{$t('project.component_FileListInside_tips_20')}}</span><i class="el-icon-arrow-right float-right"></i></div>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item command="target" v-permission="`project:detailRouter:downloadTranslations`">{{$t('project.component_FileListInside_dropdownItem_1')}}</el-dropdown-item>
                                                <el-dropdown-item command="bilingual" v-permission="`project:detailRouter:downloadBilingual`" v-if="['xlf', 'xliff', 'sdlxlf', 'sdlxliff'].indexOf(scope.row.fileType) < 0">{{$t('project.component_FileListInside_dropdownItem_2')}}</el-dropdown-item>
                                                <el-dropdown-item command="ts-bilingual" v-permission="`project:detailRouter:downloadBilingual`" v-if="['xlf', 'xliff', 'sdlxlf', 'sdlxliff'].indexOf(scope.row.fileType) < 0">{{$t('project.component_FileListInside_dropdownItem_6')}}</el-dropdown-item>
                                                <el-dropdown-item command="source" v-permission="`project:detailRouter:downloadOriginal`">{{$t('project.component_FileListInside_dropdownItem_3')}}</el-dropdown-item>
                                                <el-dropdown-item command="tmx" v-permission="`project:detailRouter:downloadTMX`">{{$t('project.component_FileListInside_dropdownItem_4')}}</el-dropdown-item>
                                                <el-dropdown-item command="trace" v-permission="`project:detailRouter:downloadEditTrace`">{{$t('project.component_FileListInside_dropdownItem_5')}}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    <div class="operate-btn" v-permission="`project:detailRouter:history`" @click="executeAction('editWorkflow', scope.row)"><svg-icon name="ib-workflow"></svg-icon>{{$t('project.component_FileListInside_tips_21')}}</div>
                                    <div class="operate-btn" v-permission="`project:detailRouter:history`" @click="showHistory(scope.row)"><svg-icon name="ib-history"></svg-icon>{{$t('project.component_FileListInside_tips_22')}}</div>
                                    </template>
                                    <template v-if="scope.row.docStatus === 'pre-translated' || scope.row.docStatus === 'limited' || scope.row.docStatus.indexOf('error') > -1">
                                        <div class="operate-btn" v-permission="`project:detailRouter:delete`" @click="executeAction('delete', scope.row)"><svg-icon name="ib-trash-o-1"></svg-icon>{{$t('project.component_FileListInside_tips_23')}}</div>
                                    </template>
                                </div>
                                <el-button type="text" class="button-text margin-r-10" slot="reference"><svg-icon name="ib-more"></svg-icon></el-button>
                            </el-popover>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :title="$t('project.component_FileListInside_dialog_1_title')" :visible.sync="contactDialog.show" destroy-on-close width="700px" top="20px">
            <div class="margin-b-20">
                <template v-for="(item, index) in contactDialog.user">
                    <el-row :gutter="10" :key="index">
                        <el-col :span="8">{{item.alias}}</el-col>
                        <el-col :span="8">
                            {{item.phone || '—'}}
                            <span class="margin-l-5 cursor-pointer" @click="copyText(item.phone)">
                                <svg-icon name="ib-copy"></svg-icon>
                            </span>
                        </el-col>
                        <el-col :span="8">
                            {{item.email || '—'}}
                            <span class="margin-l-5 cursor-pointer" @click="copyText(item.email)">
                                <svg-icon name="ib-copy"></svg-icon>
                            </span>
                        </el-col>
                    </el-row>
                </template>
            </div>
        </el-dialog>
        <el-dialog :title="$t('project.component_FileListInside_dialog_2_title')" :visible.sync="rejectDialog.show" @closed="rejectDialogClosed" destroy-on-close width="430px" top="20px">
            <div class="text-center margin-b-10">{{$t('project.component_FileListInside_dialog_2_tips_1')}}<span class="text-weight-600 margin-x-5">{{rejectDialog.task.taskTypeDesc}}</span>{{$t('project.component_FileListInside_dialog_2_tips_2')}}</div>
            <el-form>
                <el-form-item :label="$t('project.component_FileListInside_dialog_2_formItem_label_1')" required>
                    <el-input v-model="rejectDialog.reason" type="textarea" rows="3" :placeholder="$t('project.component_FileListInside_dialog_2_formItem_input_placeholder_1')"></el-input>
                </el-form-item>
            </el-form>
            <div class="text-center" slot="footer">
                <el-button round plain size="small" @click="rejectDialog.show = false">{{$t('project.component_FileListInside_dialog_2_btn_1')}}</el-button>
                <el-button type="primary" round size="small" :loading="rejectDialog.loading" @click="submitRejectEvent">{{$t('project.component_FileListInside_dialog_2_btn_2')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('project.component_FileListInside_dialog_3_title')" :visible.sync="historyDialog.show" destroy-on-close width="600px" top="20px">
            <div class="flex flex-align-center margin-b-20">
                <div class="file-icon" style="height: 40px; width: 40px; font-size: 20px; line-height: 40px">
                    <svg-icon :name="`ic-${config.FILE_TYPE_MATCH['.' + historyDialog.row.fileType] ? config.FILE_TYPE_MATCH['.' + historyDialog.row.fileType].icon : ''}`"></svg-icon>
                </div>
                <span class="fonts-15">{{historyDialog.row.originalFilename}}</span>
            </div>
            <el-timeline>
                <el-timeline-item :timestamp="item.happenTime" placement="top" v-for="(item, i) in historyDialog.list" :key="i">{{item.description}}</el-timeline-item>
            </el-timeline>
        </el-dialog>
        <el-dialog :title="$t('project.component_FileListInside_dialog_4_title')" :visible.sync="splitDialog.show" @open="splitDialogOpenEvent" @closed="splitDialogClosedEvent" destroy-on-close :width="typeRadioSelected === 'manual' ? '70%' : '480px'" top="20px">
            <!-- <type-radio :list="typeRadioOptions" :active="typeRadioSelected" @change="typeRadioChange" class="flex-justify-center margin-b-15" ></type-radio> -->
            <template v-if="typeRadioSelected === 'manual'">
                <div class="manual-split-table">
                    <el-table :data="splitDialog.pageList" ref="splitDialogTable" border @selection-change="handleSplitDialogSelectionChange" row-key="paragraphId" :max-height="pageTabelHeight">
                        <el-table-column type="selection" :selectable="handleSetSplitDialogSelectionEnable" reserve-selection width="45"></el-table-column>
                        <el-table-column :label="$t('project.component_FileListInside_dialog_4_table_column_1')" type="index" width="80" :index="splitDialogTableIndexMethod"></el-table-column>
                        <el-table-column :label="$t('project.component_FileListInside_dialog_4_table_column_2')">
                            <template slot-scope="scope">
                                <ul class="sentence-list">
                                    <template v-for="(item, index) in scope.row.sentences">
                                        <li :key="index">{{item.sourceText}}</li>
                                    </template>
                                </ul>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('project.component_FileListInside_dialog_4_table_column_3')" prop="targetText">
                            <template slot-scope="scope">
                                <ul class="sentence-list">
                                    <template v-for="(item, index) in scope.row.sentences">
                                        <li :key="index">{{item.targetText}}</li>
                                    </template>
                                </ul>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('project.component_FileListInside_dialog_4_table_column_4')" prop="blockNum" width="80">
                            <template slot-scope="scope">
                                <template>{{scope.row.blockNum || '-'}}</template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="flex margin-t-15">
                    <div class="flex-1">
                        <el-tooltip :content="$t('project.component_FileListInside_dialog_4_tips_3')" placement="top">
                            <el-button plain round size="small" @click="splitBtnEvent">{{$t('project.component_FileListInside_dialog_4_btn_3')}}</el-button>
                        </el-tooltip>
                        <el-checkbox v-model="splitDialog.otherSplitChecked" class="margin-l-15">{{$t('project.component_FileListInside_dialog_4_tips_4')}}</el-checkbox>
                    </div>
                    <div class="flex-1 text-right">
                        <el-pagination 
                            background 
                            @current-change="handleSplitDialogCurrentChange"
                            @size-change="handleSplitDialogSizeChange"
                            :current-page.sync="splitDialog.pageNumber"
                            :page-size="splitDialog.pageSize"
                            :total="splitDialog.total"
                            :pager-count="5"
                            :page-sizes="[20, 50, 100, 200]"
                            layout="total, sizes, prev, pager, next">
                        </el-pagination>
                    </div>
                </div>
                <div class="margin-t-15">
                    <template v-for="(item, index) in splitDialog.splitList">
                        <el-tag @close="splitItemCloseEvent(item, index)" :key="index" 
                            closable disable-transitions effect="plain" 
                            class="radius-20 margin-r-10 margin-b-8">
                            {{$t('project.component_FileListInside_dialog_4_tips_5', {size1: index + 1, size2: item.paragraphIds.length, size3: item.sentenceCount, range: `${item.paragraphRange[0].start}-${item.paragraphRange[0].end}`})}}
                        </el-tag>
                    </template>
                </div>
            </template>
            <template v-else>
                <div class="flex flex-justify-center">
                    <div class="flex flex-align-center">
                        <span class="margin-r-5">{{$t('project.component_FileListInside_dialog_4_tips_1')}}</span>
                        <el-input-number v-model="splitDialog.pieces" controls-position="right" :precision="0" :min="1" :max="10" style="width: 110px;"></el-input-number>
                        <span class="margin-l-5">{{$t('project.component_FileListInside_dialog_4_tips_2')}}</span>
                    </div>
                </div>
            </template>
            
            <div class="text-center" slot="footer">
                <el-button round plain size="small" @click="splitDialog.show = false">{{$t('project.component_FileListInside_dialog_4_btn_1')}}</el-button>
                <el-button type="primary" round size="small" :loading="splitDialog.loading" @click="submitSplitEvent">{{$t('project.component_FileListInside_dialog_4_btn_2')}}</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="$t('project.component_FileListInside_dialog_5_title')" :visible.sync="offerDialog.show" destroy-on-close width="1160px" top="20px">
            <div class="line-height-1.5">
                <div>{{$t('project.component_FileListInside_dialog_5_tips_1')}}{{offerDialog.task.totalPrice}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_2')}}{{offerDialog.task.sourceWords}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_3')}}{{offerDialog.task.priceWordCount}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_4')}}{{offerDialog.task.initPrice}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_5')}}{{offerDialog.task.currencyDesc}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_6')}}{{offerDialog.task.additionalRates}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_7')}}{{offerDialog.task.priceUnitDesc}}</div>
                <div>{{$t('project.component_FileListInside_dialog_5_tips_8')}}{{doc.name}}</div>
            </div>
            <el-divider></el-divider>
            <div class="margin-b-10">{{$t('project.component_FileListInside_dialog_5_tips_9')}}</div>
            <el-table :data="[offerDialog.task.quotationDetail]" style="width: 100%;" :header-cell-style="{'background-color': '#f5f7fa'}">
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_1')" prop="untranslated"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_2')" prop="outerRepeat"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_3')" prop="innerRepeat"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_4')" prop="match102"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_5')" prop="match101"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_6')" prop="match100"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_7')" prop="match9599"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_8')" prop="match8594"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_9')" prop="match7584"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_10')" prop="match5074"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_11')" prop="newWord"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_12')" prop="priceWordCount"></el-table-column>
              <el-table-column :label="$t('project.component_FileListInside_dialog_5_table_column_13')" prop="workPrice"></el-table-column>

            </el-table>
            <div class="text-center" slot="footer">
                <el-button round plain size="small" @click="offerDialog.show = false">{{$t('project.component_FileListInside_dialog_5_btn_1')}}</el-button>
                <el-button type="primary" round size="small" :loading="offerDialog.loading" @click="downloadOfferEvent" v-if="offerDialog.task.quotationDetail">{{$t('project.component_FileListInside_dialog_5_btn_2')}}</el-button>
            </div>
        </el-dialog>
        <task-assign-dialog ref="taskAssignDialogDom" @change="assignChangeEvent"></task-assign-dialog>
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import moment from 'moment';
import config from '@/utils/config';
import tools from '@/utils/tools';
import { docApi, teamApi, projectApi, commonApi } from '@/utils/api';
import TaskAssignDialog from './TaskAssignDialog.vue';
import LanguageDirection from '@/components/LanguageDirection';
import TypeRadio from '@/components/TypeRadio';
export default {
    name: 'FileListInside',
    components: {
        TaskAssignDialog, LanguageDirection, TypeRadio,
    },
    props: {
        doc: {
            type: Object, 
            default: {},
        },
        list: {
            type: Array,
            default: []
        },
        time: null,
        reset: '',
        listInit: '',
    },
    data () {
        return {
            moment,
            config,
            dialogShow: false,
            dialogLoading: false,
            contactDialog: {
                show: false,
                user: {},
            },
            rejectDialog: {
                show: false,
                loading: false,
                reason: '',
                task: {},
            },
            historyDialog: {
                show: false,
                row: {},
                list: [],
            },
            splitDialog: {
                show: false,
                loading: false,
                pieces: 1,
                doc: {},
                initAllList: [],
                allList: [],
                pageList: [],
                otherSplitChecked: false,
                splitList: [],
                total: 0,
                pageSize: 20,
                pageNumber: 1,
                pageTabelHeight: 0,
                selectedList: [],
            },
            pickerOptions: function (dTime) {
                return {
                    disabledDate: time => {
                        let current = moment(dTime).format('yyyy-MM-DD');
                        let now = moment(time).format('yyyy-MM-DD');
                        return moment(now).diff(moment(current)) < 0;
                    },
                    // selectableRange: '18:30:00 - 23:59:59'
                }
            },
            rowNumbers: {},
            offerDialog: {
                show: false,
                loading: false,
                task: {},
            },
            typeRadioOptions: [],
            typeRadioSelected: 'auto',
        }
    },
    created() {
        this.typeRadioOptions = [
            {key:'manual', name: this.$t('project.component_FileListInside_data_typeRadioOptions_name_1')},
            {key:'auto', name: this.$t('project.component_FileListInside_data_typeRadioOptions_name_2')}
        ];
        this.pageTabelHeight = document.body.clientHeight - 385;
    },
    methods: {
        executeAction(key,data){
            this.$emit('action', key, data);
        },
        handleMoreCommand(command,item){
            this.executeAction(command, item);
        },
        expandChangeEvent(row, expandedRows ) {
            if(row?.docStatus !== "pre-translated"){
                return;
            }
            let docIds = [];
            expandedRows.map(item => {
                docIds.push(item.docId);
            });
            if (docIds.indexOf(row.docId) > -1) {
                this.queryTaskList(row.docId);
            }
        },
        handleSelectionChange(selection) {
            this.$emit('action', 'updateSelected', selection);
        },
        handleSortChange({column, prop, order}) {
            this.$emit('action', 'updateSort', {sortBy: column.columnKey, sortMode: order === 'ascending' ? 'ASC' : order === 'descending' ? 'DESC' : ''})
        },
        generateMultiples(x, n = 500) {
            const multiples = [];
            for (let i = 0; i < n; i++) {
                multiples.push(i * x);
            }
            return multiples;
        },
        queryTaskList(docId) {
            let url = `${docApi.queryFileTaskList}?documentId=${docId}`;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    let allIds = [];
                    this.list.map(item => {
                        allIds.push(item.docId);
                    });
                    let index = allIds.indexOf(docId);
                    let list = [];
                    let row_length = 1;
                    if(res.data.pipelines.length > 0) {
                        row_length = res.data.pipelines[0].assignments.length;
                    }
                    this.rowNumbers[docId] = this.generateMultiples(row_length);
                    res.data.pipelines.map(item => {
                        let pipeline = item;
                        let assignments = item.assignments;
                        delete pipeline.assignments;
                        let _assignments = assignments.map((item, index) => {
                            return { 
                                ...item, ...pipeline, progress: item.progress,
                                parentTaskName: item.taskName,
                                taskName: `${pipeline.range.startSentenceIndex} - ${pipeline.range.endSentenceIndex}`, 
                                sentenceRange: `${pipeline.range.startSentenceIndex} - ${pipeline.range.endSentenceIndex}`,
                                rowspan: index === 0 ? assignments.length || 1 : 1, colspan: 1 
                            };
                        })
                        
                        list = list.concat(_assignments);
                    });

                    this.$emit('updateTasks', index, list, res.data.plan);
                }
            })
        },
        assignCommandEvent(command, scope) {
            if (command === 'assign') {
                this.showAssignDialog(scope);
            }else if (command === 'info') {
                this.queryMemberInfo(scope.row);
            }
        },
        showAssignDialog(scope){
            if(scope.row.status === 'FINISHED'){
                this.$message.warning(this.$t('project.component_FileListInside_method_showAssignDialog_message_1', {status: scope.row.statusDesc}))
                return;
            }
            this.$refs.taskAssignDialogDom.setShow({task: [scope.row], ids: [scope.row.taskId], doc: this.doc}, true);
        },
        assignChangeEvent(param) {
            this.queryTaskList(param.docId);
        },
        setDeadLineTime(val, pScope, scope) {
            // console.log(val);
            let index = pScope.$index;
            if(new Date(pScope.row.createTime).getTime() > val.getTime()){
                this.$message.error(this.$t('project.component_FileListInside_method_setDeadLineTime_message_1'));
                this.list[index].tasks[scope.$index].deadlineTime = '';
                return;
            }
            let deadline = moment(val).format('yyyy-MM-DD HH:mm:ss');
            let url = docApi.batchSetAssignmentDeadline;
            let postData = {
                assignmentIdList: [scope.row.assignmentId],
                deadline,
            };
            this.$ajax.post(url, postData).then(res => {
                if(res.status == 200) {
                    console.log('[INFO] 设置截止日期 %s 成功', deadline)
                }
            }).catch(err => {
                this.list[index].tasks[scope.$index].deadlineTime = '';
            })
        },
        queryMemberInfo(row){
            // console.log(row);
            this.contactDialog.user = row.assignee;
            this.contactDialog.show = true;
        },
        rejectToEvent(row) {
            this.rejectDialog.task = row;
            this.rejectDialog.show = true;
        },
        submitRejectEvent() {
            if(!this.rejectDialog.reason) {
                this.$message.error(this.$t('project.component_FileListInside_method_submitRejectEvent_message_1'));
                return;
            }
            let url = projectApi.submitRejectTo;
            let postData = {
                pipelineId: this.rejectDialog.task.pipelineId,
                toAssignmentId: this.rejectDialog.task.assignmentId,
                reason: this.rejectDialog.reason,
            };
            this.rejectDialog.loading = true;
            this.$ajax.post(url, postData).then(res => {
                if(res.status === 200) {
                    this.rejectDialog.show = false;
                    this.queryTaskList(this.rejectDialog.task.documentId);
                    this.executeAction('reload');
                }
            }).finally(() => {
                this.rejectDialog.loading = false;
            })
        },
        rejectDialogClosed() {
            this.rejectDialog = this.$options.data().rejectDialog;
        },
        showHistory(row) {
            let url = `${projectApi.queryTaskHistory}?documentId=${row.docId}`;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    this.historyDialog.row = row;
                    this.historyDialog.list = res.data;
                    this.historyDialog.show = true;
                }
            })
        },
        copyText(text){
            let self = this;
            this.$copyText(text).then(function (e) {
                self.$message.success(self.$t('project.component_FileListInside_method_copyText_message_1'));
            }, function (e) {
                self.$message.error(self.$t('project.component_FileListInside_method_copyText_message_2'));
            })
        },
        showPayCharDialog() {
            this.$router.push({path:'/account/vip', query: {view: 'char', child: true}});
        },
        getTimeText(t) {
            let tYear = moment(t).year();
            let cYear = moment().year();
            if(tYear === cYear) {
                return moment(t).format(`MM-DD HH:mm`);
            }else {
                return moment(t).format(`YYYY-MM-DD`);
            }
        },
        handleSpanMethod({row, column, rowIndex, columnIndex}) {
            if(columnIndex <= 4){
                // console.log('rowNumbers::', this.rowNumbers)
                if (this.rowNumbers[row.documentId].indexOf(rowIndex) > -1) {
                    return [row.rowspan, row.colspan];
                }else {
                    return [1, 0];
                }
            }else {
                return [1, 1];
            }
        },
        handleRowClassName({row, rowIndex}) {
            if(row.rowspan > 1) {
                return 'row-border-style';
            }
        },
        handleSetSelectionEnable(row, index) {
            return row.docStatus === "pre-translated";
        },
        showOfferDialog(row) {
            this.offerDialog.task = row;
            this.offerDialog.show = true;
        },
        downloadOfferEvent() {
            this.offerDialog.loading = true;
            let url = commonApi.batchCreateDownloadTask;
            let postData = {
                title: `${this.offerDialog.task.parentTaskName}-${this.$t('project.component_FileListInside_method_downloadOfferEvent_message_1')}`,
                metadataIdList: [this.offerDialog.task.projectId],
                metadataType: "TMS_TASK_QUOTATION",
                moreOptions: {
                    id: this.offerDialog.task.taskId,
                    type: 'TASK',
                }, 
            };
            this.$ajax.post(url, postData).then(res=>{
                if(res.status === 200){
                    this.$store.dispatch('download/createNotices', res.data.map(item => { return { ...item, show: true}}));
                }
            }).finally(()=>{
                this.offerDialog.loading = false;
            });
        },
        typeRadioChange(item){
            this.typeRadioSelected = item.key;
        },
        showSplitDialog(row) {
            this.splitDialog.show = true;
            this.splitDialog.doc = row;
            // console.log('showSplitDialog:::', row);
        },
        splitDialogOpenEvent() {
            this.queryAllList()
        },
        splitDialogClosedEvent() {
            this.splitDialog = this.$options.data().splitDialog;
        },
        submitSplitEvent() {
            let url = docApi.submitSplitDoc;
            let postData = {
                documentId: this.splitDialog.doc.docId,
            };
            if(this.typeRadioSelected === 'manual') {
                let _list = this.splitDialog.allList.filter(item => item.blockNum === '');
                if(_list.length > 0) {
                    let validParam = tools.analyzeConsecutiveNumbers(_list.map(item => item.sortNo))
                    let rangegMsg = `${validParam.segments.map(item=> {return `[${item.start}${item.end === item.start ? '': '-'+item.end}]`}).join(',')}`;
                    this.$message.error(this.$t('project.component_FileListInside_method_submitSplitEvent_message_2', {range: rangegMsg}));
                    return;
                }
                postData = {
                    documentId: this.splitDialog.doc.docId,
                    pieces: this.splitDialog.splitList.map((item, index) => {
                        return {
                            blockNum: index + 1,
                            paragraphList: item.paragraphList,
                            paragraphRange: item.paragraphRange,
                        }
                    })
                };
                // console.log('submitSplitEvent:::', postData);
                return;
            }
            postData = {
                documentId: this.splitDialog.doc.docId,
                pieces: this.splitDialog.pieces,
            };
            this.splitDialog.loading = true;
            this.$ajax.post(url, postData).then(res => {
                if(res.status === 200) {
                    this.$message.success(this.$t('project.component_FileListInside_method_submitSplitEvent_message_1'));
                    this.queryTaskList(this.splitDialog.doc.docId);
                    this.splitDialog.show = false;
                }
            }).finally(()=>{
                this.splitDialog.loading = false;
            });
        },
        queryAllList() {
            let url = `${docApi.querySplitParagraphList}?documentId=${this.splitDialog.doc.docId}`;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    let list = [];
                    res.data.map((item, index) => {
                        list.push({...item, sortNo: index + 1, blockNum: ''});
                    });
                    this.splitDialog.initAllList = list;
                    this.splitDialog.allList = list;
                    this.splitDialog.total = list.length;
                    this.setPageList();
                }
            });
        },
        setPageList(toTop = false) {
            let startIndex = (this.splitDialog.pageNumber - 1) * this.splitDialog.pageSize;
            this.splitDialog.pageList = 
                this.splitDialog.allList.slice(
                    startIndex, 
                    startIndex + this.splitDialog.pageSize
                );
            // console.log(this.splitDialog.pageList);
            this.$nextTick(() => {
                if(toTop) {
                    document.querySelector('.manual-split-table .el-table__body-wrapper').scrollTop = 0;
                }
            });
        },
        handleSplitDialogCurrentChange(val){
            this.splitDialog.pageNumber = val;
            this.setPageList(true);
        },
        handleSplitDialogSizeChange(val){
            this.splitDialog.pageSize = val;
            this.splitDialog.pageNumber = 1;
            this.setPageList(true);
        },
        async splitBtnEvent() {
            // TODO 拆分按钮事件
            if(this.splitDialog.allList.filter(item => item.blockNum === '').length === 0) {
                this.$message.success(this.$t('project.component_FileListInside_method_splitBtnEvent_message_1'));
                return;
            }
            if(!this.splitDialog.otherSplitChecked && this.splitDialog.selectedList.length === 0){
                this.$message.error(this.$t('project.component_FileListInside_method_splitBtnEvent_message_2'));
                return;
            }
            if(this.splitDialog.selectedList.length > 0) {
                this.setSplitList(this.splitDialog.selectedList);
                if(!this.splitDialog.otherSplitChecked) {
                    this.$refs.splitDialogTable?.clearSelection();
                }
            }
            if(this.splitDialog.otherSplitChecked) {
                await tools.sleep(400);
                let oList = this.splitDialog.allList.filter(item => item.blockNum === '');
                this.setSplitList(oList, this.splitDialog.otherSplitChecked);
                this.$refs.splitDialogTable?.clearSelection();
            }
        },
        /**
         * 设置拆分按钮点击后的拆分列表数据
         */
        setSplitList(list, otherSplitChecked) {
            if(list.length === 0) {
                return;
            }
            let validParam = tools.analyzeConsecutiveNumbers(list.map(item => item.sortNo));
            // console.log('setSplitList:::', validParam);
            if(!validParam.isConsecutive) {
                let rangeMsg = `${validParam.segments.map(item=> {return `[${item.start}${item.end === item.start ? '': '-'+item.end}]`}).join(',')}`;
                this.$message.error(`${otherSplitChecked ? this.$t('project.component_FileListInside_method_setSplitList_message_1'): ''}${this.$t('project.component_FileListInside_method_setSplitList_message_2',{range: rangeMsg, numbers: validParam.missingNumbers.join(',')})}`);
                return;
            }
            let paragraphList = [];
            let paragraphIds = [];
            let sentenceIds = [];
            let sentenceCount = 0;
            list.map(item => {
                paragraphIds.push(item.paragraphId);
                sentenceIds = sentenceIds.concat(item.sentences.map(sentence => sentence.sentenceId));
                sentenceCount += item.sentences.length;
                paragraphList.push({
                    ...item,
                    sentences: sentenceIds,
                })
            });
            this.splitDialog.splitList.push({
                list, 
                paragraphIds,
                sentenceIds,
                sentenceCount,
                paragraphList,
                paragraphRange: validParam.segments,
            });
        },
        handleSplitDialogSelectionChange(val) {
            this.splitDialog.selectedList = val;
        },
        splitDialogTableIndexMethod(index) {
            return this.$t('project.component_FileListInside_method_splitDialogTableIndexMethod_message_1', {number: (this.splitDialog.pageNumber - 1) * this.splitDialog.pageSize + index + 1});
        },
        handleSetSplitDialogSelectionEnable(row, index) {
            return !row.blockNum;
        },
        splitItemCloseEvent(item, index) {
            this.splitDialog.splitList.splice(index, 1);
        },
        handleUpdateSplitAllListBlockNum() {
            let list = cloneDeep(this.splitDialog.initAllList);
            this.splitDialog.splitList.map((item, index) => {
                item.paragraphIds.map(id => {
                    let _index = list.findIndex(item => item.paragraphId === id);
                    if(_index > -1) {
                        list[_index].blockNum = index + 1;
                    }
                })
            });
            // console.log('handleUpdateSplitAllListBlockNum:::', list, this.splitDialog.initAllList, this.splitDialog.splitList);
            this.splitDialog.allList = list;
            // this.splitDialog.total = list.length;
            this.$nextTick(() => {
                this.setPageList();
            })
        },
    },
    watch: {
        'reset' (newVal, oldVal) {
            this.$refs.fileListInsideTable?.clearSelection();
        },
        'listInit' (newVal, oldVal) {
            this.$refs.fileListInsideTable.toggleRowExpansion(this.list[0]);
        },
        'splitDialog.splitList' (newVal, oldVal) {
            // console.log('newVal:::', newVal);
            this.handleUpdateSplitAllListBlockNum();
        },
    }
    
}
</script>
<style lang="scss" scoped>
.file-list-inside-table {
    .table-link {
        color: #000;
        &:hover {
            text-decoration: underline;
        }
    }
    .workflow-wrapper {
        display: inline-block;
        .list {
            display: flex;
            align-items: center;
            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #999999;
                line-height: normal;
                .name {
                    margin-bottom: 5px;
                    font-size: 12px;
                }
                .point {
                    width: 10px;
                    height: 10px;
                    background-color: #fff;
                    border-radius: 50px;
                    border: 1px solid #C4C4C4;
                    box-sizing: border-box;
                }
                &.finashed {
                    .point {
                        background-color: #1AC49C79;
                        border-color: #1AC49C79;
                    }
                }
                &.active {
                    color: #000000;
                    .point {
                        background-color: #1AC49C;
                        border-color: #1AC49C;
                    }
                }
                z-index: 1;
            }
            .line {
                width: 70px;
                margin-left: -16px;
                margin-right: -8px;
                margin-bottom: -21px;
                border-top: 1px solid #ddd;
                &.dash {
                    border-style: dashed;
                }
            }
        }
    }
    .workflow-step-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        line-height: normal;
        .point {
            width: 10px;
            height: 10px;
            background-color: transparent;
            border-radius: 50px;
            border: 1px solid #C4C4C4;
            box-sizing: border-box;
        }
        &.finashed {
            .point {
                background-color: #1AC49C79;
                border-color: #1AC49C79;
            }
        }
        &.active {
            color: #000000;
            .point {
                background-color: #1AC49C;
                border-color: #1AC49C;
            }
        }
    }
    ::v-deep .el-table{
        background-color: transparent;
        &::before {
            height: 0;
            width: 0;
            bottom: -10000px;
            background-color: transparent;
        }
        th {
            padding: 10px 0;
            font-size: 14px;
            color: #999999;
        }
        .el-table__expanded-cell {
            background-color: #FFF !important;
            padding: 0;
        }
        .el-table__row {
            td {
                vertical-align: middle;
                background-color: #ffffff;
                font-size: 14px;
                padding: 10px 0;
                
                .cell {
                    .el-button--text {
                        font-size: 14px;
                        svg {
                            font-size: 18px;
                        }
                    }
                }
                
            }
            .el-table__expand-icon {
                font-size: 18px;
                width: 28px;
                height: 28px;
                text-align: center;
                line-height: 28px;
                display: inline-block;
                position: unset;
                .el-icon {
                    position: unset;
                    left: 0;
                    top: 0;
                }
            }
            &:hover {
                td {
                    background-color: #fff;
                }
            }
        }
        
    }
    .expand-table {
        ::v-deep .el-table{
            .el-table__row {
                .cell {
                    line-height: normal;
                    position: relative;
                }
                .cell-status {
                    width: 2px;
                    height: 24px;
                    background-color: #999999;
                    position: absolute;
                    left: 0;
                    top: 8px;
                    border-radius: 20px;
                    &.active {                    
                        background-color: #2979FF;
                    }
                }
                td {
                    vertical-align: middle;
                    border: none;
                    font-size: 14px;
                    padding: 15px 0;
                    /* &:first-child {
                        border-radius: 10px 0 0 10px;
                    }
                    &:last-child {
                        border-radius: 0 10px 10px 0;
                    } */
                    &.eidt-col {
                        padding: 0px !important;
                        cursor: pointer;
                        &:hover {
                            background-color: #f8f8f8;
                        }
                        .cell {
                            height: 40px;
                        }
                        .el-date-editor {
                            .el-input__inner {
                                padding: 0px;
                                border: none;
                                background-color: transparent;
                                font-size: 14px;
                                color: #000000;
                                cursor: pointer;
                            }
                        }
                        .timeout {
                            .el-input__inner{
                                color: #F56C6C;
                            }
                        }
                    }
                }
                &.row-border-style {
                    td {
                        border-top: 1px solid #E6E6E6;
                    }
                }
            }
        }
        .timeout {
            color: #F56C6C;
        }
        .task-label {
            // margin-left: 12px;
        }
    }
    .task-progress {
        display: inline-block;
        width: 198px;
        position: relative;
        .percentage {
            width: 100%;
            position: absolute;
            top: 0;
            line-height: 20px;
            text-align: center;
            color: #1AC49C;
            font-weight: 500;
        }
    }
}
.ASSIGNED {
    color: #FF9900;
}
.REJECTED {
    color: #F56C6C;
}
.file-icon {
    display: inline-block;
    height: 32px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    background-color: #F8F8F8;
    border-radius: 50px;
    font-size: 18px;
    margin-right: 12px;
}
.contact-type-block{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #F2F2F2;
    font-size: 20px;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sentence-list {
    list-style: none;
    padding-left: 0;
    padding-left: 0;
    counter-reset: sentence-counter;
    li {
        display: flex;
        align-items: baseline;
        &:before {
            content: counter(sentence-counter) ".";
            counter-increment: sentence-counter;
            color: #999;
            font-size: 12px;
            text-align: right;
            min-width: 16px;
            margin-right: 4px;
            font-feature-settings: "tnum";
        }
    }
}

</style>
<style lang="scss">
.operate-popover {
    padding-left: 0px;
    padding-right: 0px;
    .operate-btn {
        padding: 0 15px;
        font-size: 12px;
        line-height: 36px;
        cursor: pointer;
        &:hover {
            background-color: #eaeaea;
        }
        svg {
            font-size: 14px;
            margin-right: 5px;
        }
    }
}
.download-operate-dropdown {
    display: block;
}
.el-picker-panel.hide-time {
    .el-button--text.el-picker-panel__link-btn {
        display: none;
    }
}
.manual-split-table {
    .el-table {
        .cell {
            white-space: normal !important;
        }
        // .el-table__row td {
        //     vertical-align: baseline !important;
        // }
    }
}
</style>
